import * as types from "../../mutation-types.js";
import http from "@service/http";
import { tokenCall, restCall } from "@service/adapter";
import util from "@common/utils/util";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";

/**
 * 安装指导-STORE
 */
const PAGENOPRO = "PAGENOPRO";
const LASTPAGEPRO = "LASTPAGEPRO";
const INSTALL_STUDY_LISTS = "INSTALL_STUDY_LISTS";
export default {
  state: {
    installStudyList: [],
    pageNoPro: 1,
    lastPagePro: 1,
  },
  actions: {
    //分页获取安装指导列表
    pageInstallStudy({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall(Constant.tokenCallUrl + "/mxoa/study/page", data)
        .then((result) => {
          if (result && result.data) {
            commit(INSTALL_STUDY_LISTS, result.data.list);
            commit(LASTPAGEPRO, result.data.lastPage);
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取安装指导详情
    getInstallStudyDetail({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/study/getContent",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    [INSTALL_STUDY_LISTS](state, list) {
      if (state.pageNoPro == 1) {
        state.installStudyList = [];
      }

      state.installStudyList = state.installStudyList.concat(list);
    },
    [PAGENOPRO](state, pageNo) {
      state.pageNoPro = pageNo;
    },
    [LASTPAGEPRO](state, lastPagePro) {
      state.lastPagePro = lastPagePro;
    },
  },
  getters: {
    installStudyList: (state) => {
      return state.installStudyList;
    },
    pageNoPro: (state) => {
      return state.pageNoPro;
    },
    lastPagePro: (state) => {
      return state.lastPagePro;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/install-study/index.js